import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
var VeltCommentsSidebarV2FilterContainerGroupBy = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-container-v2-group-by-wireframe", __assign({}, transformedProps), children));
};
export default VeltCommentsSidebarV2FilterContainerGroupBy;
